import React from 'react'
import {
    EmptyCircle as DisabledRadio,
    Radio as EnabledRadio
} from 'app/assets/icons'

type Props = {
    checked: boolean
}

const Radio = (props: Props) => {
    const { checked } = props
    return checked ? <EnabledRadio /> : <DisabledRadio />
}

export { Radio }
